function saveLoginSession(username) {
    sessionStorage.setItem('username', username);
}

function getUserFromSession(){
    return sessionStorage.getItem('username');
}

function saveJWT(token) {
    sessionStorage.setItem('jwt', token);
}

function deleteJWT() {
    sessionStorage.removeItem('jwt');
}

function getJWT() {
    return sessionStorage.getItem('jwt');
}

async function generateSHA256(input) {
    const encoder = new TextEncoder(); // Create a new TextEncoder
    const data = encoder.encode(input); // Encode the input string as a Uint8Array

    const hashBuffer = await crypto.subtle.digest('SHA-256', data); // Generate the hash
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convert buffer to byte array
    const hashHex =  hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // Convert bytes to hex string

    return hashHex; // Return the hex string
}

const getTimeString = (unix) => {
    if(unix === undefined || unix === null){
        return "Zukünftig";
    }

    const now = Math.floor(Date.now() / 1000); // Aktueller Zeitpunkt in Sekunden
    const diff = now - unix; // Differenz in Sekunden

    if( diff < 0 ){
        return `0 Minuten`;
    }
    else if (diff < 3600) { // Weniger als 1 Stunde
        const minutes = Math.floor(diff / 60);
        return `${minutes} Minuten`;
    } else if (diff < 86400) { // Weniger als 24 Stunden
        const hours = Math.floor(diff / 3600);
        return `${hours} Stunden`;
    } else { // Mehr als 24 Stunden
        const date = new Date(unix * 1000);
        const day = date.getDate();
        const monthNames = ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sept.", "Okt.", "Nov.", "Dez."];
        const month = monthNames[date.getMonth()];
        return `${day}. ${month}`;
    }
}

const trimChatLastMessage = ( message ) => {
    if( message === undefined ){
        return "Soo leer hier.";
    }

    if( message.length > 30 ){
        return message.substring(0, 40) + "...";
    }else{
        return message;
    }
}

export {
    saveLoginSession,
    saveJWT,
    deleteJWT,
    getJWT,
    generateSHA256,
    getUserFromSession,
    trimChatLastMessage,
    getTimeString
}